<template>
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="el-card pd20 search">
      <div class="search-box">
        <!-- 测评名称 -->
        <el-input class="input" v-model="nickname" @keyup.enter.native="pullData()" placeholder="请输入用户名称"></el-input>
        <el-button type="primary" class="btn" @click="pullData()" size="small">查 询</el-button>
        <el-button type="primary" class="btn" @click="exportExcelHandle()" size="small">导出数据</el-button>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column label="买家头像/昵称">
            <template slot-scope="scope">
              <div class="userinfo">
                <img :src="scope.row.headimgurl" alt />
                {{scope.row.nickname}}
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="性别">
              <template slot-scope="scope">
                    <el-tag v-if="scope.row.gender==1" >男</el-tag>
                    <el-tag v-if="scope.row.gender==2" >女</el-tag>
                </template>
          </el-table-column>
          <el-table-column prop="email" label="邮箱"></el-table-column>
          <el-table-column prop="age" label="年龄"></el-table-column>
          <el-table-column prop="city" label="工作城市"></el-table-column>
          <el-table-column prop="degree" label="学历"></el-table-column>
          <el-table-column prop="state" label="在职状态"></el-table-column>
          <el-table-column prop="job" label="从事职业"></el-table-column>
          <el-table-column prop="workage" label="工作年限"></el-table-column>
          <el-table-column prop="income" label="年收入"></el-table-column>
          <el-table-column prop="scale" label="公司规模"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        class="pages"
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pages.size"
        :current-page="pages.page"
        background
        layout="sizes,prev, pager, next"
        :total="pages.count"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { userinfoList,userinfoExport } from "@/api/measurement";
import { exportExcel } from "@u/tools";
export default {
  data() {
    return {
      list: [],
      pages: {},
      nickname: ''
    };
  },
  watch: {
    status(newval, oldval) {
      this.pullData();
    }
  },
  methods: {
    /*
     *@Description: 导出表格
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-28 18:27:09
    */
    exportExcelHandle(){
        let h = ['昵称','性别','邮箱','工作城市','学历','在职状态','从事职业','工作年限','年收入','公司规模'];
        let b =  ['nickname','gender','email','city','degree','state','job','workage','income','scale'];

        userinfoExport(this.obj).then((res)=>{
            let list = res.list;  //把data里的tableData存到list
            for(let key in list){
                // 性别转换
                if(list[key].gender ==1){
                    list[key].gender =  '男';
                }
                if(list[key].gender ==2){
                    list[key].gender =  '女';
                }
            }
            exportExcel(h,b,list,'买家用户信息')

        })
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      this.pages.size = val;
      this.pullData();
    },
    // 触发分页
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pullData();
    },
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      let obj = {
        page: this.pages ? this.pages.page : null, //页码，默认1
        size: this.pages ? this.pages.size : null //每页数量，默认25
      };
      obj["nickname"] = this.nickname;
      userinfoList(obj)
        .then(data => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },
  created() {
    this.pullData();
  }
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.pages {
  text-align: right;
  margin-top: 30px;
}

.search {
  margin-bottom: 20px;
  .search-box {
    display: flex;
    align-items: center;
    label {
      font-size: 16px;
      color: #606266;
    }
    .on {
      margin: 0 80px;
    }
    .input {
      width: 500px;
    }
    .btn {
      margin-left: auto;
      &:last-child{
        margin-left: 40px;
      }
    }
  }
}
</style>
